export class DeleteGalleryPhoto {
    constructor(optionalOptions = {}) {
        this._deletes = document.querySelectorAll('[data-action="delete-photo"]');

        if (!this._deletes) {
            this.destructor();
            return true;
        }

        this._deletes.forEach((button) => {
            button.addEventListener("click", (event) => {
                event.preventDefault()

                window.closeAllModals();
                window.showModal('modal-user-gallery-delete-photo')

                return false
            })
        })
    }

    destructor() {
        this._deletes = null;
    }
}

export default new DeleteGalleryPhoto();